import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCartData } from '../../../hooks/order';
import { getValid$Cost, calculateTotalMonthlyCharge } from '../../../common/common';

// Mobile Review & Pay price summary (desktop shows the full cart in the sidebar instead).
const ChargeBreakdown = () => {
  const { t } = useTranslation();
  const {
    isInternetAdded,
    internetPlan,
    internetPlanPrice,
    isWhiAdded,
    isScheduleSuppressed,
    modemFee,
    monthlyCharge,
    isBundleAdded,
    bundleDiscount,
    getOneTimeChargesLabel,
    getOneTimeChargesLabelValue,
    getOneTimeChargesHeadingValue,
  } = useCartData();

  const totalMonthly = calculateTotalMonthlyCharge(monthlyCharge, isBundleAdded, bundleDiscount);
  const planName = internetPlan?.serviceName?.replace(/^earthlink /i, '');

  return (
    <>
      <div className="spc-charge-breakdown">
        <div className="spc-charge-breakdown__row spc-charge-breakdown__row--heading">
          <span>{t('cart.oneTimeChargesSpc')}*</span>
          <span>{getOneTimeChargesHeadingValue()}</span>
        </div>
        {isInternetAdded && (
          <div className="spc-charge-breakdown__row">
            <span>{getOneTimeChargesLabel()}</span>
            <span>{getOneTimeChargesLabelValue()}</span>
          </div>
        )}

        <div className="spc-charge-breakdown__divider" />

        <div className="spc-charge-breakdown__row spc-charge-breakdown__row--heading">
          <span>{t('cart.monthlyCharges')}*</span>
          <span>{getValid$Cost(totalMonthly)}</span>
        </div>
        {isInternetAdded && (
          <>
            <div className="spc-charge-breakdown__row">
              <span>{planName}</span>
              <span>{getValid$Cost(internetPlanPrice)}</span>
            </div>
            <div className="spc-charge-breakdown__row">
              <span>{(isWhiAdded && internetPlan?.equipmentShortName) || t('cart.modemLease')}</span>
              <span>{getValid$Cost(modemFee)}</span>
            </div>
          </>
        )}

        <div className="spc-charge-breakdown__divider" />

        <div className="spc-charge-breakdown__row spc-charge-breakdown__row--heading">
          <span>{t('fixedFooter.dueToday')}</span>
          <span className="spc-charge-breakdown__due">{getOneTimeChargesHeadingValue()}</span>
        </div>
      </div>
      <p className="spc-cart-taxes-note spc-charge-breakdown__note">
        {isScheduleSuppressed ? t('cart.taxesNoteActivated') : t('cart.taxesNoteInstalled')}
      </p>
    </>
  );
};

export default ChargeBreakdown;
